
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';

interface RequestReviewToggleProps {
  requestReview: boolean;
  setRequestReview: (value: boolean) => void;
}

export const RequestReviewToggle: React.FC<RequestReviewToggleProps> = ({
  requestReview,
  setRequestReview
}) => {
  return (
    <div className="flex items-start space-x-2 mb-4">
      <Checkbox
        id="request-review"
        checked={requestReview}
        onCheckedChange={(checked) => setRequestReview(checked === true)}
      />
      <div className="grid gap-1.5 leading-none">
        <Label
          htmlFor="request-review"
          className="text-sm font-medium leading-none flex items-center gap-2"
        >
          Request Peer Review
          <Badge variant="outline" className="font-normal text-xs">
            Recommended
          </Badge>
        </Label>
        <p className="text-sm text-muted-foreground">
          Request a review from peers to improve your paper before publication
        </p>
      </div>
    </div>
  );
};
